import I18n from 'I18n';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { trackInteractionWithId, TrackingScreen, TrackingSubscreen, TrackingFeature, TrackingAction } from '../../../app/utils/tracking';
import { utcToRolloutOffsetLocal } from '../../../app/utils/dateUtils';
import { FeedbackBtnClickTrackerContext, MeetingScheduleLinkClickTrackerContext } from '../../contexts/Tracking';
import JoinEnrollmentButton from '../EnrollmentButtons/JoinEnrollmentButton';
import LeaveEnrollmentButton from '../EnrollmentButtons/LeaveEnrollmentButton';
import RequestToJoinEnrollmentButton from '../EnrollmentButtons/RequestToJoinEnrollmentButton';
import FeedbackButton from '../FeedbackButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RolloutProductDetailsPanelFooter = ({
  enrolled,
  isBeta,
  rolloutProductUpdate
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const {
    ctaUrl,
    id: productUpdateId,
    releaseDate,
    rollout: {
      betaPaused: isBetaClosed,
      id: rolloutId,
      enrollmentStatus,
      enrollType,
      gate
    },
    translatedContent: {
      callToAction
    },
    untranslatedTitle,
    title,
    rolloutState,
    userFeedbackSubmissionInfo
  } = rolloutProductUpdate;
  const hasCtaButton = callToAction && ctaUrl;
  const thirtyDaysAgo = utcToRolloutOffsetLocal(I18n.moment()).subtract(30, 'days');
  const isLiveInThirtyDays = rolloutState === 'LIVE' && releaseDate && utcToRolloutOffsetLocal(releaseDate).isAfter(thirtyDaysAgo);
  const isEnrolledBeta = enrolled && isBeta;
  const showBetaFeedbackButton = isEnrolledBeta;
  const showLiveFeedbackButton = isLiveInThirtyDays;
  const lastSubmittedDate = userFeedbackSubmissionInfo === null || userFeedbackSubmissionInfo === void 0 ? void 0 : userFeedbackSubmissionInfo.latestSubmissionTimeStamp;
  const btnUsePrimary = isTrellis ? 'primary' : 'tertiary';
  const btnUseSecondary = isTrellis ? 'secondary' : 'tertiary-light';
  return /*#__PURE__*/_jsx(PanelFooter, {
    children: /*#__PURE__*/_jsxs(Flex, Object.assign({}, showBetaFeedbackButton || hasCtaButton && showLiveFeedbackButton ? null : {
      inlineSize: '100%'
    }, {
      gap: "200",
      children: [showBetaFeedbackButton && /*#__PURE__*/_jsx(FeedbackBtnClickTrackerContext.Provider, {
        value: {
          screen: TrackingScreen.PRODUCT_UPDATES,
          subscreen: TrackingSubscreen.UPDATE_PANEL,
          origin: 'panel',
          rolloutState: rolloutState === 'PRIVATE_BETA' || rolloutState === 'PUBLIC_BETA' ? rolloutState : null,
          untranslatedPUTitle: untranslatedTitle
        },
        children: /*#__PURE__*/_jsx(MeetingScheduleLinkClickTrackerContext.Provider, {
          value: {
            screen: TrackingScreen.PRODUCT_UPDATES,
            subscreen: TrackingSubscreen.UPDATE_PANEL,
            origin: 'panel'
          },
          children: /*#__PURE__*/_jsx(FeedbackButton, {
            use: btnUsePrimary,
            rolloutId: rolloutId,
            productUpdateId: productUpdateId,
            productUpdateTitle: title,
            lastSubmittedDate: lastSubmittedDate
          })
        })
      }), !enrolled && rolloutState === 'PUBLIC_BETA' && /*#__PURE__*/_jsx(JoinEnrollmentButton, {
        enrollType: enrollType,
        enrollmentStatus: enrollmentStatus,
        gate: gate,
        productUpdateId: productUpdateId,
        isBetaClosed: isBetaClosed,
        rolloutId: rolloutId,
        title: title,
        untranslatedTitle: untranslatedTitle
      }), !enrolled && rolloutState === 'PRIVATE_BETA' && /*#__PURE__*/_jsx(RequestToJoinEnrollmentButton, {
        enrollType: enrollType,
        enrollmentStatus: enrollmentStatus,
        gate: gate,
        productUpdateId: productUpdateId,
        isBetaClosed: isBetaClosed,
        rolloutId: rolloutId,
        title: title,
        untranslatedTitle: untranslatedTitle
      }), enrolled && isBeta && /*#__PURE__*/_jsx(LeaveEnrollmentButton, {
        enrollmentStatus: enrollmentStatus,
        enrollType: enrollType,
        gate: gate,
        productUpdateId: productUpdateId,
        rolloutId: rolloutId,
        rolloutState: rolloutState,
        title: title,
        untranslatedTitle: untranslatedTitle
      }), !isBeta && hasCtaButton && /*#__PURE__*/_jsx(Button, {
        block: true,
        href: ctaUrl,
        external: true,
        use: "primary",
        onClick: () => trackInteractionWithId(TrackingScreen.PRODUCT_UPDATES, TrackingSubscreen.UPDATE_PANEL, TrackingFeature.CTA_FOOTER, TrackingAction.CLICK, `product update ID ${productUpdateId}`),
        children: callToAction
      }), showLiveFeedbackButton && /*#__PURE__*/_jsx(FeedbackBtnClickTrackerContext.Provider, {
        value: {
          screen: TrackingScreen.PRODUCT_UPDATES,
          subscreen: TrackingSubscreen.UPDATE_PANEL,
          origin: 'panel',
          rolloutState: 'LIVE',
          untranslatedPUTitle: untranslatedTitle
        },
        children: /*#__PURE__*/_jsx(MeetingScheduleLinkClickTrackerContext.Provider, {
          value: {
            screen: TrackingScreen.PRODUCT_UPDATES,
            subscreen: TrackingSubscreen.UPDATE_PANEL,
            origin: 'panel'
          },
          children: /*#__PURE__*/_jsx(FeedbackButton, {
            use: hasCtaButton ? btnUseSecondary : btnUsePrimary,
            rolloutId: rolloutId,
            productUpdateId: productUpdateId,
            productUpdateTitle: title,
            lastSubmittedDate: lastSubmittedDate
          })
        })
      })]
    }))
  });
};
export default RolloutProductDetailsPanelFooter;